export default {
    _prefix: "languagePicker",
    labels: {
        defaultSurveyLanguage: "Default Survey Language",
    },
};
